module.exports = __webpack_public_path__ + "img/main-boardroom.644aae61.png";